(ns ycweb.app.website.dlp.widgets.html
  (:require
   [rum.core :as rum]))

(rum/defc html-block [_ _ {:keys [properties]}]
  (let [{:keys [html]} properties]
    [:div
     (when html
       {:dangerouslySetInnerHTML
        {:__html html}})]))
